import type { DistributionRepeatUnit } from "../DistributionScheduleFields/DistributionScheduleFields.types";
import type { EndsMode } from "../../../utils/storyRefreshTypes";

export const SENTENCE_COPY = {
  once: "Send once on",
  every: "Every",
  at: "at",
  on: "on",
  inTheQuarterMonth: "in the",
  starting: "starting",
  ending: "ending",
  sends: "sends",
  send: "send",
  weekdaysLabel: "On",
} as const;

const UNIT_WORDS: Record<DistributionRepeatUnit, [string, string]> = {
  day: ["day", "days"],
  week: ["week", "weeks"],
  month: ["month", "months"],
  quarter: ["quarter", "quarters"],
};

/** The unit select's options, singular or plural to match the stepper. */
export const unitOptions = (every: number): { value: DistributionRepeatUnit; label: string }[] =>
  (Object.keys(UNIT_WORDS) as DistributionRepeatUnit[]).map((value) => ({
    value,
    label: UNIT_WORDS[value][every === 1 ? 0 : 1],
  }));

export const ENDS_OPTIONS: { value: EndsMode; label: string }[] = [
  { value: "never", label: "never" },
  { value: "on", label: "on date" },
  { value: "after", label: "after" },
];
